if (!customElements.get('tilo-free-sock-promo')) {
  customElements.define(
    'tilo-free-sock-promo',
    class TiloFreeSockPromo extends HTMLElement {
      constructor() {
        super();
        /** @type {HTMLFormElement | null} */
        this._boundForm = null;
        /** @type {(ev: SubmitEvent) => void} | null */
        this._onSubmitCapture = null;
      }

      connectedCallback() {
        const productInfo = this.closest('product-info');
        const formId = this.dataset.productFormId;
        const form = formId
          ? document.getElementById(formId)
          : productInfo?.querySelector('ajax-cart-product-form form[action*="/cart/add"]');
        if (!form || !form.closest('ajax-cart-product-form')) return;

        const sizeButtons = this.querySelectorAll('.tilo-free-sock-promo__size[data-sock-variant-id]');
        if (!sizeButtons.length) return;

        this._boundForm = form;

        const clearSelection = () => {
          sizeButtons.forEach((b) => b.classList.remove('is-selected'));
        };

        const selectButton = (btn) => {
          if (btn.hasAttribute('disabled')) return;
          clearSelection();
          btn.classList.add('is-selected');
        };

        sizeButtons.forEach((btn) => {
          btn.addEventListener('click', () => selectButton(btn));
        });

        const ensureSelection = () => {
          const current = this.querySelector('.tilo-free-sock-promo__size.is-selected');
          if (current && !current.hasAttribute('disabled')) return;
          const firstAvailable = this.querySelector(
            '.tilo-free-sock-promo__size[data-sock-variant-id]:not([disabled])'
          );
          if (firstAvailable) {
            clearSelection();
            firstAvailable.classList.add('is-selected');
          }
        };

        ensureSelection();

        this._onSubmitCapture = (event) => {
          if (this.dataset.promoActive !== 'true') return;

          const addBtn = form.querySelector('button[type="submit"][name="add"]');
          if (addBtn?.disabled) return;

          const selected = this.querySelector('.tilo-free-sock-promo__size.is-selected[data-sock-variant-id]');
          if (!selected || selected.hasAttribute('disabled')) return;

          const rawId = selected.getAttribute('data-sock-variant-id');
          const sockVariantId = rawId ? Number(rawId) : NaN;
          if (!sockVariantId || Number.isNaN(sockVariantId)) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          const formData = new FormData(form);
          const tiloId = formData.get('id');
          const qtyRaw = formData.get('quantity');
          const quantity = qtyRaw ? Math.max(1, parseInt(String(qtyRaw), 10) || 1) : 1;

          if (!tiloId) return;

          const tiloItem = {
            id: Number(tiloId),
            quantity,
          };

          const tiloProps = {};
          formData.forEach((value, key) => {
            if (!value || typeof key !== 'string') return;
            const m = /^properties\[(.+)]$/.exec(key);
            if (m) tiloProps[m[1]] = String(value);
          });
          if (Object.keys(tiloProps).length) tiloItem.properties = tiloProps;

          const sockItem = {
            id: sockVariantId,
            quantity: 1,
          };
          const pk = this.dataset.propertyKey;
          const pv = this.dataset.propertyValue;
          if (pk && pv) {
            sockItem.properties = { [pk]: pv };
          }

          const spinner = addBtn?.querySelector('.loading__spinner');
          if (addBtn) addBtn.disabled = true;
          spinner?.classList.remove('hidden');

          const cleanup = () => {
            if (addBtn) addBtn.disabled = false;
            spinner?.classList.add('hidden');
          };

          if (typeof window.liquidAjaxCart?.add !== 'function') {
            cleanup();
            return;
          }

          const handleRequestEnd = (/** @type {CustomEvent} */ e) => {
            const { requestState } = e.detail || {};
            if (!requestState || requestState.requestType !== 'add') return;
            document.removeEventListener('liquid-ajax-cart:request-end', handleRequestEnd);
            if (requestState.responseData?.ok) {
              document.body.classList.add('js-show-ajax-cart');
            }
          };
          document.addEventListener('liquid-ajax-cart:request-end', handleRequestEnd);

          window.liquidAjaxCart.add(
            { items: [tiloItem, sockItem] },
            {
              lastCallback: () => {
                document.removeEventListener('liquid-ajax-cart:request-end', handleRequestEnd);
                cleanup();
              },
            }
          );
        };

        form.addEventListener('submit', this._onSubmitCapture, true);
      }

      disconnectedCallback() {
        if (this._boundForm && this._onSubmitCapture) {
          this._boundForm.removeEventListener('submit', this._onSubmitCapture, true);
        }
        this._boundForm = null;
        this._onSubmitCapture = null;
      }
    }
  );
}
